import { Pipe, PipeTransform } from '@angular/core';
import { camelCase } from 'lodash';

@Pipe({
  name: 'camelCase',
})
export class CamelCasePipe implements PipeTransform {
  transform(value: string): string {
    return camelCase(value);
  }
}
